function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * 
 * @file class for Box marker based API's to inherit common functionality from
 * @author Box
 */
import { getTypedFileId } from '../utils/file';
import Base from './Base';

class MarkerBasedApi extends Base {
  /**
   * @property {Data}
   */

  /**
   * Determines if the API has more items to fetch
   *
   * @param {string} marker the marker from the start to start fetching at
   * @return {boolean} true if there are more items
   */
  hasMoreItems(marker) {
    return marker !== null && marker !== '';
  }
  /**
   * Helper for get
   *
   * @param {string} id the file id
   * @param {string} marker the marker from the start to start fetching at
   * @param {number} limit the number of items to fetch
   * @param {Object} requestData the request query params
   * @param {boolean} shouldFetchAll true if should get all the pages before calling
   * @private
   */


  async markerGetRequest(id, marker, limit, shouldFetchAll) {
    let requestData = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    if (this.isDestroyed()) {
      return;
    } // Make the XHR request


    try {
      const url = this.getUrl(id);

      const queryParams = _objectSpread({}, requestData, {
        marker,
        limit
      });

      const {
        data
      } = await this.xhr.get({
        url,
        id: getTypedFileId(id),
        params: queryParams
      });
      const entries = this.data ? this.data.entries : [];
      this.data = _objectSpread({}, data, {
        entries: entries.concat(data.entries)
      });
      const nextMarker = data.next_marker;

      if (shouldFetchAll && this.hasMoreItems(nextMarker)) {
        this.markerGetRequest(id, nextMarker, limit, shouldFetchAll, requestData);
        return;
      }

      this.successHandler(this.data);
    } catch (error) {
      this.errorHandler(error);
    }
  }
  /**
   * Marker based API get
   * @param {Object} options
   * @param {string} options.id the file id
   * @param {Function} options.successCallback the success callback
   * @param {Function} options.errorCallback the error callback
   * @param {string} [options.marker] the marker from the start to start fetching at
   * @param {number} [options.limit] the number of items to fetch
   * @param {Object} options.requestData the request query params
   * @param {boolean} [options.shouldFetchAll] true if should get all the pages before calling the sucessCallback
   */


  async markerGet(_ref) {
    let {
      id,
      successCallback,
      errorCallback,
      marker = '',
      limit = 1000,
      requestData,
      shouldFetchAll = true
    } = _ref;
    this.successCallback = successCallback;
    this.errorCallback = errorCallback;
    return this.markerGetRequest(id, marker, limit, shouldFetchAll, requestData);
  }

}

export default MarkerBasedApi;
//# sourceMappingURL=MarkerBasedAPI.js.map